import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MenuService } from 'src/app/servicios/menu/menu.service';
import { LoaderService } from 'src/app/component/loader-spinner/loader.service';

@Injectable({ providedIn: 'root' })
export class ApiHelperService {
  private menu = inject(MenuService);
  private loader = inject(LoaderService);


  // Envuelve un observable con bloqueo global y spinner. No maneja success/error.
  runWithBlock<T>(obs: Observable<T>, showSpinner = true): Observable<T> {
    this.menu.bloqueo(true);
    if (showSpinner) this.loader.showSpinner();
    return obs.pipe(
      finalize(() => {
        this.menu.bloqueo(false);
        if (showSpinner) this.loader.hideSpinner();
      })
    );
  }
}